import { initAuthenticatedTracking, initUnauthenticatedTracking } from '@/tracking'
import { defineStore } from 'pinia'

export const useTrackingStore = defineStore('tracking', {
  state: () => ({
    _initializedTracking: false,
    _initializedAuthenticatedTracking: false,
  }),
  actions: {
    initTracking() {
      if (!this._initializedTracking) {
        this._initializedTracking = true
      }
    },
    initAuthenticatedTracking(payload: { user: { name: string, email: string }, toolkit_account: object, license: object, domains: { name: string }[], schools: object[], enable_fullstory: boolean }) {
      if (!this._initializedAuthenticatedTracking) {
        try {
          initAuthenticatedTracking(payload)
        } catch (err) {
          console.error(`Could not fully init app: ${err}`)
        }
        this._initializedAuthenticatedTracking = true
      }
    },
    initUnauthenticatedTracking(payload: { enable_fullstory: boolean }) {
      if (!this._initializedAuthenticatedTracking) {
        try {
          initUnauthenticatedTracking(payload)
        } catch (err) {
          console.error(`Could not initialize unauthenticated tracking: ${err}`)
        }
      }
    }
  }
})